import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=5637a922&scoped=true&"
import script from "./Notifications.vue?vue&type=script&setup=true&lang=js&"
export * from "./Notifications.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5637a922",
  null
  
)

export default component.exports